import axios from 'axios';
import AxiosConfiguration from '@/classes/AxiosConfiguration';

const ApiUrl = 'documentexport';

export const DocumentExportService = {
  async queueBackgroundExportAsync(model: any): Promise<void> {
    const response = await axios.post(`${ApiUrl}/queuebackgroundexport`, model);
    return response.data;
  },
  async backgroundExportAsync(model: any): Promise<void> {
    const response = await axios.post(`${ApiUrl}/backgroundexport`, model);
    return response.data;
  },
  async getExportZipFileAsync(backgroundTaskId: number, fileNumber: number) {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(`${ApiUrl}/backgroundexportzip/${backgroundTaskId}/${fileNumber}`, { responseType: 'blob' });
    return response;
  }
};
